import * as ActionType from '../../core/ActionType';
import { ApiCallBeginAction } from '../api/Action';
import { setErrorResponse } from '../responses/Action';
import { TipoPagamentoService } from './Service';

/**
 * 
 * @param {Objeto completo contendo a lista de Vinculo Transporte} tipoPagamentoObject 
 */
export const getTiposPagamentosResponse = tipoPagamentoObject => ({
    type: ActionType.GET_TIPO_PAGAMENTO_RESPONSE,
    tipoPagamentoObject
});


export function getTiposPagamentosAction() {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));
        dispatch(ApiCallBeginAction());
        
        try {
            let tipoPagamentoObject = await TipoPagamentoService.getTiposPagamentos()
            dispatch(getTiposPagamentosResponse(tipoPagamentoObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}